/**
 * Helpers para gerar links wa.me (click-to-WhatsApp) — não envia automaticamente,
 * apenas abre a conversa no WhatsApp do usuário com a mensagem pré-preenchida.
 */
export function normalizePhone(phone) {
  if (!phone) return null;
  // Remove tudo que não é dígito
  let digits = String(phone).replace(/\D/g, "");
  if (digits.length === 0) return null;
  // Se for número BR sem DDI (10 ou 11 dígitos), prefixa 55
  if (digits.length === 10 || digits.length === 11) digits = "55" + digits;
  return digits;
}

export function buildWhatsAppUrl(phone, message) {
  const digits = normalizePhone(phone);
  if (!digits) return null;
  const text = message ? `?text=${encodeURIComponent(message)}` : "";
  return `https://wa.me/${digits}${text}`;
}

export function openWhatsApp(phone, message) {
  const url = buildWhatsAppUrl(phone, message);
  if (!url) return false;
  window.open(url, "_blank", "noopener,noreferrer");
  return true;
}
